import * as actions from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmContext } from 'legacy/lut/components/shared/Confirm/ConfirmContext'
import { useContext } from 'react'

export function useConfirm() {
  const [confirmState, dispatch, resolveRef] = useContext(ConfirmContext)

  const confirm = (dialogIdentifier: ConfirmDialogIdentifier) => {
    dispatch(actions.showConfirmDialog(dialogIdentifier))

    return new Promise<boolean>((resolve) => {
      resolveRef.current[dialogIdentifier] = resolve
    })
  }

  const onConfirm = (dialogIdentifier: ConfirmDialogIdentifier) => {
    dispatch(actions.hideConfirmDialog(dialogIdentifier))
    const resolve = resolveRef.current[dialogIdentifier]

    if (resolve) {
      resolve(true)
      resolveRef.current[dialogIdentifier] = undefined
    }
  }

  const onCancel = (dialogIdentifier: ConfirmDialogIdentifier) => {
    dispatch(actions.hideConfirmDialog(dialogIdentifier))
    const resolve = resolveRef.current[dialogIdentifier]

    if (resolve) {
      resolve(false)
      resolveRef.current[dialogIdentifier] = undefined
    }
  }

  const registerConfirmDialog = (dialogIdentifier: ConfirmDialogIdentifier) => {
    dispatch(actions.registerConfirmDialog(dialogIdentifier))
    resolveRef.current[dialogIdentifier] = undefined
  }

  const unregisterConfirmDialog = (dialogIdentifier: ConfirmDialogIdentifier) => {
    dispatch(actions.unregisterConfirmDialog(dialogIdentifier))
    delete resolveRef.current[dialogIdentifier]
  }

  return {
    confirmState,
    confirm,
    onConfirm,
    onCancel,
    registerConfirmDialog,
    unregisterConfirmDialog,
  }
}
